class NewFacilityModalService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Create a new facility.
     *
     * @param campusId      the ID of the parent campus for this facility.
     * @param facilityName  the name of the facility.
     */
    createFacility(campusId, facilityName) {
        const data = {
            name: facilityName
        };
        return this.$http.post(`${this.appConfig.apiUrl}/campuses/${campusId}/facilities/`, data);
    }

}

export default NewFacilityModalService;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-facility-modal/new-facility-modal-service.js